import BotApi from 'api/bot';
import withContentLoader from 'components/ui/withContentLoader';
import ShortBotCard from './ShortBotCard';
import { Link } from 'react-router-dom';

const MarketBotList = ({ data = [] }) => {
  const limited_data = data.splice(0, 3);
  const bots = limited_data.map(bot => (
    <div key={bot.id} className="col-md-4 mb-4">
      <ShortBotCard {...bot} />
    </div>
  ));

  return (
    <div style={{}}>
      <h6>Conheça alguns de nossos bots</h6>
      <div className="row">{bots}</div>
      <div className="text-center">
        <Link to="/marketplace" className="btn btn-outline-primary">
          Veja mais
        </Link>
      </div>
    </div>
  );
};

const fetchData = async () => BotApi.fetchPublic();
export default withContentLoader(MarketBotList, { name: 'notfound_explore_bots', fetchData });
